module.exports = __webpack_public_path__ + "img/chery-logo-mobile.f3e968e7.png";